import { Provider } from 'react-redux'
import Home from 'pages/Home/Home'
import EtudierMarche from 'pages/EtudierMarche/EtudierMarche'
import TripleGrow from 'components/Loading/TripleGrow'
import { PersistGate } from 'redux-persist/integration/react'
import RechercheBiensAVendre from 'pages/BiensAVendre/BiensAVendre'
import Favoris from 'pages/Favoris/Favoris'
import BienUtiliser from 'pages/BienUtiliser/BienUtiliser'
import store, { history, persistor } from 'redux/store'
import { ConnectedRouter } from 'connected-react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import MapContextProvider from './contexts/MapContextProvider'
import 'styles/app.scss'

// test
const App = () => (
  <Provider store={store}>
    {/* Connect react-router to redux */}
    <ConnectedRouter history={history}>
      {/* Show loading while retrieving data from local storage */}
      <PersistGate loading={<TripleGrow />} persistor={persistor}>
        <MapContextProvider>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/etudier-votre-marche">
              <EtudierMarche />
            </Route>
            <Route path="/biens-a-vendre">
              <RechercheBiensAVendre />
            </Route>
            <Route path="/favoris">
              <Favoris />
            </Route>
            <Redirect from="/bien-utiliser-geociblage" to="/bien-utiliser" />
            <Route path="/bien-utiliser">
              <BienUtiliser />
            </Route>
          </Switch>
        </MapContextProvider>
      </PersistGate>
    </ConnectedRouter>
  </Provider>
)

export default App
